import { z } from 'zod';

export const getDaysWithoutSprayingResponseSchema = z.record(z.string().uuid(), z.number());
